import { useSearch, useNavigate } from "@tanstack/react-router";
import { indexRoute } from "../../../routes";
import { Algo, AlgoConfiguration } from "../types";

export const GHOSTBOOK_ALGO = "ghostbook";

export const isGhostbook = (algo: Algo<AlgoConfiguration>) =>
  algo.algo_spec?.name === GHOSTBOOK_ALGO;

export const useHideGhostbooks = () => {
  const { ghostbooks } = useSearch({ from: indexRoute.id });
  const navigate = useNavigate({ from: indexRoute.id });

  const setHideGhostbooks = (hide: boolean) => {
    navigate({
      search: (prev) => ({
        ...prev,
        ghostbooks: hide ? undefined : "shown",
      }),
    });
  };

  return [ghostbooks !== "shown", setHideGhostbooks] as const;
};
